///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

const updatePricingGridDetails = state => {
  const lanes = state.lanes;
  const filteredLanes =
    lanes && lanes.filter && lanes.filter(l => l.metaData.matched);
  state.totalFiltered = filteredLanes ? filteredLanes.length : 0;
  let sum = 0;
  let count = 0;
  filteredLanes &&
    filteredLanes.forEach(({ margin }) => {
      if (margin || margin === 0) {
        sum += margin;
        count++;
      }
    });
  state.averageMargin = sum / (count || 1);
  state.averageMargin = Math.round(state.averageMargin * 100) / 100;
};

export default updatePricingGridDetails;
